export function getMonthName(date: Date, nameType: 'short' | 'long') {
  return date.toLocaleString('en-EN', { month: nameType });
}

export function takeYearBackMonthNames(monthNames: Array<string>) {
  const today = new Date();
  const currentMonth = today.getMonth() + 1;
  return [...monthNames.slice(currentMonth), ...monthNames.slice(0, currentMonth)];
}
